import { App } from "vue";
import store from "@/store";

// /**
//  * 判断用户是否拥有操作权限
//  * 根据传入的权限标识，查看是否存在用户权限标识集合
//  * @param perms
//  */
// export function hasPermission(perms) {
//   let hasPermission = false;
//   let permissions = store.state.rule;

//   if (permissions[0] === "*") {
//     hasPermission = true;
//   }

//   for (let i = 0, len = permissions.length; i < len; i++) {
//     if (permissions[i] === perms) {
//       hasPermission = true;
//       break;
//     }
//   }

//   return hasPermission;
// }

/**
 * 权限判断是否能看到这个按钮，同时后端也做了校验，前端只是显示与不显示
 * @param {string, array} data 按钮的权限点，可以是单个字符串，也可以是数组
 * @param {string} rule or代表或，and代表与
 * 使用方法：
 * 例如 buttonCodeList 的数据为： ['button1', 'button2', 'button3']
 * 想要判断 button1 的权限，可以写成：hasPerm('button1')、v-auth="'system:user:add'"
 * 想要判断 button1 或 button2 的权限，可以写成：hasPerm(['button1', 'button2' ])、v-auth="['system:user:add','system:user:read']"
 * 想要判断 button1 与 button2 的权限，可以写成：hasPerm(['button1', 'button2' ], 'and')、v-auth:and="['system:user:add','system:user:read']"
 */
export function hasPerm(data, rule = 'or') {
  if (!data) {
    return false
  }
  const userInfo = store.state.user
  if (!userInfo) {
    return false
  }
  const buttonCodeList = store.state.rule
  if (!buttonCodeList) {
    return false
  }
  if (Array.isArray(data)) {
    const fn = rule === 'or' ? 'some' : 'every'
    return data[fn]((item) => buttonCodeList.includes(item))
  }
  return buttonCodeList.includes(data)
}